import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X, Sparkles, ArrowRight } from "lucide-react";

const SHOWN_KEY = "be_exit_intent_shown";

/** Shows once-per-session save offer when mouse leaves through top edge. */
export default function ExitIntentOffer() {
  const [open, setOpen] = useState(false);
  const fired = useRef(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (sessionStorage.getItem(SHOWN_KEY)) return;
    if (pathname.startsWith("/admin") || pathname.startsWith("/practice/") || pathname.startsWith("/checkout")) return;

    const onLeave = (e) => {
      if (fired.current) return;
      if (e.clientY <= 0) {
        fired.current = true;
        sessionStorage.setItem(SHOWN_KEY, "1");
        setOpen(true);
      }
    };
    document.addEventListener("mouseout", onLeave);
    return () => document.removeEventListener("mouseout", onLeave);
  }, [pathname]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] grid place-items-center bg-black/55 p-4" onClick={() => setOpen(false)} data-testid="exit-intent-modal">
      <div className="relative w-full max-w-md rounded-2xl border border-border bg-card p-8 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => setOpen(false)} className="absolute top-3 right-3 rounded-md p-1.5 hover:bg-accent" aria-label="Close" data-testid="exit-intent-close">
          <X className="h-4 w-4" />
        </button>
        <div className="inline-flex items-center gap-1.5 rounded-full bg-[color:var(--brand-amber-soft)] px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-[color:var(--brand-amber-hover)]">
          <Sparkles className="h-3 w-3" /> Wait — before you go
        </div>
        <h2 className="mt-4 font-display text-2xl tracking-tight">
          Take an extra <span className="font-serif text-gradient-gold">15% off</span>
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Use code <span className="font-mono font-bold text-foreground rounded bg-muted px-2 py-0.5">SAVE15</span> at checkout — stacks on top of any active sale. One-time, this session only.
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          <Link to="/marketplace" onClick={() => setOpen(false)}>
            <button className="btn-primary" data-testid="exit-intent-cta">
              Shop now <ArrowRight className="h-4 w-4" />
            </button>
          </Link>
          <button className="btn-ghost" onClick={() => setOpen(false)}>No thanks</button>
        </div>
      </div>
    </div>
  );
}
